import React from 'react'
import PropTypes from 'prop-types'
import JoinMeetingBody from '../../utils/components/joinMeeting/JoinMeetingBody'

const JoinMeeting = props => {
    return (
        <>
            <JoinMeetingBody />
        </>
    )
}

JoinMeeting.propTypes = {

}

export default JoinMeeting
